<template lang="pug">
  modal(:title='title' @closeModal='closeModal')
    .column.center
      .column.center.text-center.m-bottom-2
        simple-svg.blue-stroke-icon.m-bottom-4(:filepath='tutorialIcon' width='55px' height='55px')
        h2.title-medium.bold.m-bottom-2 {{ $t('activateTutorialModal.title') }}
        p.text-normal.dark-gray {{ $t('activateTutorialModal.message') }}
      button.primary-button(@click='activateTutorial') {{ $t('activateTutorialModal.activate') }}
</template>

<script>
import { mapActions } from 'vuex'
import tutorialIcon from '@/assets/ic_tutorial.svg'
import Modal from '../Modal'
import { routes } from '../../router'

export default {
  components: { Modal },
  data() {
    return {
      tutorialIcon
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'setNavigationTutorialStatus'
    ]),
    closeModal() {
      this.hideElement({ element: 'activateTutorialModal' })
    },
    async activateTutorial() {
      const success = await this.setNavigationTutorialStatus(true)
      if (success) {
        this.closeModal()
        this.$router.push({ name: routes.feed })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
